module.exports = __webpack_public_path__ + "static/media/chiapas_sancristobalplus.d4772873.png";